import BaseAPI, { querySuffix } from "./BaseAPI";

/**
 * Base client for V2 cursor-paginated list routes.
 *
 * ListPage exposes the transport-level page for useInfiniteQuery and other
 * incremental consumers. List preserves the existing complete-array contract
 * by following continuation tokens until the traversal is complete.
 */
export default class CursorPaginatedAPI extends BaseAPI {
    constructor(emitterInstance, route, entityName, defaultPageSize) {
        super(emitterInstance, route, entityName);
        this.defaultPageSize = defaultPageSize;
    }

    async ListPage(params = {}) {
        const response = await this._request(
            "get",
            this._url(
                querySuffix({
                    ...params,
                    limit: params.limit || this.defaultPageSize
                })
            ),
            null,
            { fullResponse: true }
        );
        return {
            data: response.data.data || [],
            next_page_token: response.data.next_page_token || ""
        };
    }

    async List(params = {}) {
        const items = [];
        let pageToken = params.page_token || null;
        do {
            const page = await this.ListPage({ ...params, page_token: pageToken });
            items.push(...page.data);
            pageToken = page.next_page_token || null;
        } while (pageToken);
        return items;
    }
}
